import CellDetailModal from "./CellDetailModal";
import CellInfoPopover from "./CellInfoPopover";
// ColumnHeaderDialog removed - now using unified GridLineConfirmationModal
import DrawingConfirmationDialog from "./DrawingConfirmationDialog";
import GridLineConfirmationModal from "./GridLineConfirmationModal";
import RecoveryMenu from "./RecoveryMenu";
import React from "react";

/**
 * PdfViewerModals Component - Collection of all modal dialogs for PDF Table Viewer
 * Centralizes modal management and reduces clutter in main component
 */
const PdfViewerModals = ({
  // Modal states
  cellInfoAnchor,
  showDrawingConfirmation,
  showGridLineConfirmation,
  showCellDetail,
  showRecoveryMenu,
  recoveryMenuAnchor,

  // Modal data
  selectedCell,
  selectedWordIndex,
  pendingShapeWords,
  selectedTable,
  pendingGridLineChanges,
  currentPage,
  selectedCellDetail,
  deletedRows,
  deletedColumns,

  // Refs for grid line confirmation
  beforeTableRef,
  afterTableRef,
  pdfPageDimensions,

  // Confidence filtering
  confidenceFilterEnabled,
  confidenceThreshold,

  // Event handlers
  modalState,
  handleWordClick,
  confirmDrawing,
  isMultiPageTable,
  getTablePages,
  getCellDifferences,
  renderTablePreview,
  handleTableScroll,
  confirmGridLineChanges,
  cancelGridLineChanges,
  handleCellDetailClick,
  recoverRowById,
  recoverColumnById,
  recoverAllRows,
  recoverAllColumns,
}) => {
  return (
    <>
      {/* Cell Info Popover */}
      <CellInfoPopover
        open={Boolean(cellInfoAnchor)}
        anchorEl={cellInfoAnchor}
        onClose={() => modalState.setCellInfoAnchor(null)}
        selectedCell={selectedCell}
        selectedWordIndex={selectedWordIndex}
        onWordClick={handleWordClick}
        confidenceFilterEnabled={confidenceFilterEnabled}
        confidenceThreshold={confidenceThreshold}
      />

      {/* Drawing Confirmation Dialog */}
      <DrawingConfirmationDialog
        open={showDrawingConfirmation}
        onClose={() => modalState.setShowDrawingConfirmation(false)}
        pendingShapeWords={pendingShapeWords}
        selectedTable={selectedTable}
        onConfirm={confirmDrawing}
      />

      {/* Grid Line Confirmation Modal */}
      <GridLineConfirmationModal
        open={showGridLineConfirmation}
        onClose={() => modalState.setShowGridLineConfirmation(false)}
        pendingGridLineChanges={pendingGridLineChanges}
        currentPage={currentPage}
        isMultiPageTable={() => isMultiPageTable(selectedTable)}
        getTablePages={() => getTablePages(selectedTable)}
        getCellDifferences={getCellDifferences}
        renderTablePreview={(tableData, title, isAfter, scrollRef, onScroll) =>
          renderTablePreview(
            tableData,
            title,
            isAfter,
            scrollRef,
            onScroll,
            pendingGridLineChanges,
            selectedTable,
            pdfPageDimensions,
            currentPage,
            handleCellDetailClick,
            modalState
          )
        }
        beforeTableRef={beforeTableRef}
        afterTableRef={afterTableRef}
        handleTableScroll={handleTableScroll}
        onConfirm={(columnName) => confirmGridLineChanges(true, columnName)}
        onCancel={cancelGridLineChanges}
        selectedTable={selectedTable}
        pdfPageDimensions={pdfPageDimensions}
        handleCellDetailClick={handleCellDetailClick}
        modalState={modalState}
      />

      {/* Cell Detail Modal */}
      <CellDetailModal
        open={showCellDetail}
        onClose={() => modalState.setShowCellDetail(false)}
        selectedCellDetail={selectedCellDetail}
      />

      {/* Column Header Input Dialog - REMOVED: Now using unified GridLineConfirmationModal */}

      {/* Enhanced Recovery Menu - Rows and Columns */}
      <RecoveryMenu
        open={showRecoveryMenu}
        anchorEl={recoveryMenuAnchor}
        onClose={() => {
          modalState.setShowRecoveryMenu(false);
          modalState.setRecoveryMenuAnchor(null);
        }}
        deletedRows={deletedRows}
        deletedColumns={deletedColumns}
        recoverRowById={recoverRowById}
        recoverColumnById={recoverColumnById}
        recoverAllRows={recoverAllRows}
        recoverAllColumns={recoverAllColumns}
      />
    </>
  );
};

export default PdfViewerModals;
